import { COUNTRIES } from '@wareclouds/frontend-common';
import env from '@/config/env';

const BYTES_PER_MB = 1024 * 1000;
const MAX_FILE_SIZE_MB = 10;
const MAX_FILE_SIZE = BYTES_PER_MB * MAX_FILE_SIZE_MB;
const METER_TO_KILOMETER = 1000;
const CONTEXT = env.CONTEXT || 'cl';
const IS_CL_CONTEXT = CONTEXT === 'cl';
const IS_BR_CONTEXT = CONTEXT === 'br';
const PUSH_PERMISSION_PROMPT_INTERVAL_MS = 1000 * 30 * 30;
const MAX_ATTEMPTS_LOCATION = 3;
const GEOLOCATION_TIMEOUT_MS = 10000;
const GEOLOCATION_MAXIMUM_AGE_MS = 60000;
const UPLOAD_TIMEOUT_MS = 3 * 60 * 1000;
const PATH_BANK_ACCOUNT = '/profile/bank-account';

const API_KEY = env.MAP_API_KEY;

const REJECTION_COMMENT_TYPES = {
  WRONG_ADDRESS: 1,
  ADDRESS_NOT_FOUND: 2,
  DANGEROUS_SECTOR: 3,
  CUSTOMER_NO_ANSWER: 4,
  CUSTOMER_CANCELS_ORDER: 5,
  CUSTOMER_NOT_KNOWN: 6,
  CUSTOMER_DOESNT_KNOW_ORDER: 7,
  BRAND_CANCELS_ORDER: 8,
  INSUFFICIENT_TIME: 9,
  OTHER: 10,
};

const ENTEL_RETIROS_HOGAR_REJECTION_COMMENT_TYPES = {
  CUSTOMER_DISTRUSTS_PICKUP: 'CUSTOMER_DISTRUSTS_PICKUP',
  CUSTOMER_DELIVERED_TO_ENTEL_STORE: 'CUSTOMER_DELIVERED_TO_ENTEL_STORE',
};

const NOTIFICATION_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
};

const FALLBACKLNG = {
  [COUNTRIES.CL]: 'es',
  [COUNTRIES.BR]: 'pt',
};

const ERRORS_GEOLOCATION = {
  PERMISSION_DENIED: 1,
  POSITION_UNAVAILABLE: 2,
  TIMEOUT: 3,
};

const GEOLOCATION_ERRORS = {
  [ERRORS_GEOLOCATION.PERMISSION_DENIED]: 'LOCATION_PERMISSION_DENIED',
  [ERRORS_GEOLOCATION.POSITION_UNAVAILABLE]: 'LOCATION_UNAVAILABLE',
  [ERRORS_GEOLOCATION.TIMEOUT]: 'LOCATION_TIMEOUT',
};

const PAYMENT_CARD_TYPES = {
  METRIC: 'metric',
  PERFORMANCE: 'performance',
  DETAILS: 'details',
};

const CONTEXTS_WITH_POSTAL_CODE = ['br', 'cl'];

Object.freeze({
  BYTES_PER_MB,
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE,
  METER_TO_KILOMETER,
  NOTIFICATION_TYPES,
  CONTEXT,
  IS_CL_CONTEXT,
  IS_BR_CONTEXT,
  PUSH_PERMISSION_PROMPT_INTERVAL_MS,
  API_KEY,
  FALLBACKLNG,
  ENTEL_RETIROS_HOGAR_REJECTION_COMMENT_TYPES,
  REJECTION_COMMENT_TYPES,
  MAX_ATTEMPTS_LOCATION,
  GEOLOCATION_ERRORS,
  GEOLOCATION_TIMEOUT_MS,
  GEOLOCATION_MAXIMUM_AGE_MS,
  UPLOAD_TIMEOUT_MS,
  CONTEXTS_WITH_POSTAL_CODE,
  PATH_BANK_ACCOUNT,
  PAYMENT_CARD_TYPES,
});

export {
  BYTES_PER_MB,
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE,
  METER_TO_KILOMETER,
  NOTIFICATION_TYPES,
  CONTEXT,
  IS_CL_CONTEXT,
  IS_BR_CONTEXT,
  PUSH_PERMISSION_PROMPT_INTERVAL_MS,
  API_KEY,
  FALLBACKLNG,
  ENTEL_RETIROS_HOGAR_REJECTION_COMMENT_TYPES,
  REJECTION_COMMENT_TYPES,
  MAX_ATTEMPTS_LOCATION,
  GEOLOCATION_ERRORS,
  GEOLOCATION_TIMEOUT_MS,
  GEOLOCATION_MAXIMUM_AGE_MS,
  UPLOAD_TIMEOUT_MS,
  CONTEXTS_WITH_POSTAL_CODE,
  PATH_BANK_ACCOUNT,
  PAYMENT_CARD_TYPES,
};
